
import { Switch, Form, Input, InputNumber } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from "react-i18next"
import PhoneInput from "react-phone-input-2"
import 'react-phone-input-2/lib/style.css'


const CountryCodeSelect = ({ value, onChange }) => (
    <PhoneInput
        country={value || 'in'}
        value=""
        specialLabel=""
        enableSearch={true}
        countryCodeEditable={false}
        onChange={(phone, data) => onChange?.(data?.countryCode)}
    />
)

const ContactForm = ({ formValues, form, showPreviousDataFetch = false }) => {
    const { t } = useTranslation();

    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="placeholder" label={t("Placeholder")}>
                <Input placeholder={t("Enter placeholder")} />
            </Form.Item>

            <Form.Item name="tooltip" label={t("Tooltip")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label="" name="helpText">
                    <TextArea rows={2} placeholder={t("Enter help text")} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t("Mandatory")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t("Read Only")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            {
                showPreviousDataFetch &&
                <Form.Item name="enablePreviousDataFetch" label={t("Enable Previous Data Fetch")} className="horizontal-form-item">
                    <Switch size="small" />
                </Form.Item>
            }
            <Form.Item name="countryCode" label={t("Country Code")}>
                <CountryCodeSelect />
            </Form.Item>

            {/* Min/Max value constraints */}
            <Form.Item
                name="minValue"
                label={t("Minimum")}
                dependencies={["maxValue"]}
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            const max = getFieldValue("maxValue")
                            if (value === undefined || value === null || value === "") return Promise.resolve()
                            if (max !== undefined && max !== null && max !== "" && Number(value) > Number(max)) {
                                return Promise.reject(new Error(t("Minimum cannot be greater than Maximum")))
                            }
                            return Promise.resolve()
                        }
                    })
                ]}
            >
                <InputNumber placeholder={t("Enter minimum value")} style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item
                name="maxValue"
                label={t("Maximum")}
                dependencies={["minValue"]}
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            const min = getFieldValue("minValue")
                            if (value === undefined || value === null || value === "") return Promise.resolve()
                            if (min !== undefined && min !== null && min !== "" && Number(value) < Number(min)) {
                                return Promise.reject(new Error(t("Maximum cannot be less than Minimum")))
                            }
                            return Promise.resolve()
                        }
                    })
                ]}
            >
                <InputNumber placeholder={t("Enter maximum value")} style={{ width: "100%" }} />
            </Form.Item>

        </>
    )
}

export default ContactForm